export const LIVE_SESSION_STATUS_COLORS = {
  PENDING: {
    timer_text: 'Expires',
    timer_info: 'Time until this request will be automatically canceled if not accepted',
    via: 'via-action-ondark-base',
    text: 'text-action-ondark-base',
    background: 'bg-action-ondark-base'
  },
  RESCHEDULING: {
    timer_text: 'Cancels',
    via: 'via-action-ondark-base',
    text: 'text-action-ondark-base',
    background: 'bg-action-ondark-base'
  },
  RESCHEDULED: {
    timer_text: 'Expires',
    timer_info: 'Time until this request will be automatically canceled if not accepted',
    via: 'via-action-ondark-base',
    text: 'text-action-ondark-base',
    background: 'bg-action-ondark-base'
  },
  CONFIRMED: {
    timer_text: 'Starts',
    timer_info: 'Time until this live session begins',
    via: 'via-ondark-primary',
    text: 'text-neon-400',
    background: 'bg-ondark-primary'
  },
  COMPLETED: { via: 'via-functional-g20', text: 'text-functional-g20', background: 'bg-functional-g20' },
  CANCELED: { via: 'via-nl-2', text: 'text-ondark-secondary', background: 'bg-onlight-low' },
  DISPUTED: { via: 'via-nl-2', text: 'text-ondark-secondary', background: 'bg-onlight-low' }
};

export const EVENT_STATUS_COLORS = {
  SCHEDULED: {
    via: 'via-ondark-primary',
    text: 'text-ondark-primary',
    background: 'bg-onlight-low'
  }
};

export const REVIEW_STATUS_COLORS = {
  draft: { via: '', text: 'text-ondark-primary', background: 'bg-ondark-medium' },
  purchased: { via: 'via-nl-2', text: 'text-ondark-secondary', background: 'bg-neutrals-l50' },
  pending: {
    timer_text: 'Expires',
    timer_info: 'Time until this request will be automatically canceled if not accepted',
    via: 'via-a-5',
    text: 'text-action-ondark-base',
    background: 'bg-action-ondark-active'
  },
  rejected: { via: 'via-functional-r50', text: 'text-functional-r50', background: 'bg-functional-r50' },
  expired: { via: 'via-functional-r50', text: 'text-functional-r50', background: 'bg-functional-r50' },
  completed: {
    timer_text: 'Finalizes',
    timer_info: 'Time until the comment period closes and this Replay Review is finalized',
    via: 'via-functional-g40',
    text: 'text-functional-g40',
    background: 'bg-functional-g40'
  },
  finalized: { via: 'via-functional-g30', text: 'text-ondark-primary', background: 'bg-functional-g30' },
  'in-progress': {
    timer_text: 'Due',
    timer_info: 'Time until this Replay Review should be completed',
    via: 'via-functional-b10',
    text: 'text-functional-b10',
    background: 'bg-functional-b10'
  },
  overdue: {
    timer_text: 'Past due',
    timer_info: 'Time past due since the coach was scheduled to complete this Replay Review',
    via: 'text-action-ondark-base',
    text: 'text-action-ondark-base',
    background: 'bg-action-ondark-base'
  },
  due: {
    timer_text: 'Due',
    timer_info: 'Time until this Replay Review should be completed',
    via: 'via-functional-r50',
    text: 'text-functional-r50',
    background: 'bg-functional-r50'
  }
};

export const PLAN_STATUS_COLORS = {
  pending: { text: 'text-action-ondark-base', background: 'bg-functional-y20' },
  confirmed: { text: 'text-functional-b10', background: 'bg-functional-b10' },
  completed: { text: 'text-functional-g20', background: 'bg-functional-g20' },
  canceled: { text: 'text-ondark-secondary', background: 'bg-neutrals-l50' },
  disputed: { text: 'text-ondark-secondary', background: 'bg-neutrals-l50' }
};

export const TRANSACTION_COLORS = {
  pending: { text: 'text-action-ondark-base', background: 'bg-a-8' },
  completed: { text: 'text-positive-ondark-base', background: 'bg-positive-ondark-base' },
  refunded: { text: 'text-ondark-secondary', background: 'bg-neutrals-l50' }
};
